function captureColorValue(event) {
  try {
    const colorValue = event.target.value;
    
    const colorEquivalents = {
      '裸色': '(Beige)',
      '米色': '(Beige)',
      '柔沙': '(Sand)',
      '焦糖': '(Caramel)',
      '可可': '(Cocoa)',
      '淺色': '(Light)',
      '深膚色': '(Medium)',
      '深色': '(Dark)',
      '黑色': '(Black)',
      '純白': '(White)',
      '粉紅': '(Blush)',
      '粉紅': '(Blush)',
      '櫻花': '(Blush)',
      '香檳': '(Champange)',
      '奶油': '(Cream)',
      '灰褐': '(Taupe)',
      '古銅': '(Bronze)',
      '黑色': '(Onyx)',
      '象牙白': '(Ivory)',
      '咖啡棕': '(Coffee)',
      '蜜桃粉': '(Peach)',
      '霜白': '(Frost)',
      '午夜藍': '(Midnight Blue)',
      '鼠尾草綠': '(Sage)',
      '黑': '(Black)',
      '囍紅': '(Cherry)',
      '柔綠': '(Sage)',
      '深夜藍': '(Midnight Blue)',
      '淺雲藍': '(Frost)',
      '桃花': '(Peach)',
      '咖啡': '(Coffee)',
      '奶白': '(Ivory)',
      '高級黑': '(Onyx)',
      '幸運藍': '(Bridal Blue)',
      
    };
 
    const equivalentColorValue = colorEquivalents[colorValue] || '';
    
    const displayDivColor = document.getElementById('color-value');
    if (displayDivColor) {
      displayDivColor.textContent = equivalentColorValue;
    }
  } catch (error) {
    console.error('Error in captureColorValue:', error);
  }
}

function initializeColorPicker() {
  try {

    const colorRadioButtons1 = document.querySelectorAll('input[name="顏色"]');
    const colorRadioButtons2 = document.querySelectorAll('input[name="胸墊顏色"]');
    
    const allColorRadioButtons = [
      ...colorRadioButtons1, 
      ...colorRadioButtons2
    ];
    
    if (allColorRadioButtons.length === 0) {
      console.warn('No color radio buttons found');
      return;
    }
    
    allColorRadioButtons.forEach(button => {
      button.addEventListener('change', captureColorValue);
    });

    const initiallyCheckedButton1 = document.querySelector('input[name="顏色"]:checked');
    const initiallyCheckedButton2 = document.querySelector('input[name="胸墊顏色"]:checked');
    
    if (initiallyCheckedButton1) {
      captureColorValue({ target: initiallyCheckedButton1 });
    } else if (initiallyCheckedButton2) {
      captureColorValue({ target: initiallyCheckedButton2 });
    }
    
    console.log('Color picker initialized successfully');
  } catch (error) {
    console.error('Error initializing color picker:', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeColorPicker);
} else {
  initializeColorPicker();
}